<template>
  <div v-if="hasMultipleVenues" class="venues">
    <CheckInput
      type="button"
      class="category"
      v-for="(venue, key) in venues"
      :key="venue.name"
      :fname="key"
      :model-value="venue.selected"
      @update:model-value="(v) => setVenueFilterLocal(key, v)"
      :label="venue.name"
    ></CheckInput>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import CheckInput from '../Form/CheckInput.vue';

export default {
  name: 'VenueFilter',
  components: { CheckInput },
  computed: {
    ...mapState({
      hasMultipleVenues: (state) => state.guidedTours.hasMultipleVenues,
      venues: (state) => state.guidedTours.venues,
    }),
  },
  methods: {
    ...mapActions({
      setVenueFilter: 'guidedTours/setVenueFilter',
    }),
    setVenueFilterLocal(key, v) {
      this.setVenueFilter({ [key]: v });
      this.setUrlQuery();
    },
    setUrlQuery() {
      const query = JSON.parse(JSON.stringify(this.$route.query));
      const selectedVenues = [];
      Object.keys(this.venues).forEach((k) => {
        if (this.venues[k].selected) {
          selectedVenues.push(this.venues[k].name);
        }
      });
      query.venues = selectedVenues;
      this.$router.replace({ query });
    },
    parseQuery() {
      const { query } = this.$route;
      if (typeof query.venues !== 'undefined') {
        if (typeof query.venues === 'string') {
          // transform string into array
          query.venues = [query.venues];
        }
        query.venues.forEach((v) => {
          Object.keys(this.venues).forEach((id) => {
            if (this.venues[id].name === v) {
              this.setVenueFilter({ [id]: true });
            }
          });
        });
      }
    },
  },
  mounted() {
    this.parseQuery();
  },
};
</script>

<style lang="scss" scoped>
.category {
  margin-left: 2.5px;
  margin-right: 2.5px;
}

.venues {
  padding-left: $sp;
  padding-right: $sp;
}

.fade-enter-active button,
.fade-leave-active button {
  transition: all 1s;
}
.fade-enter button,
.fade-leave-to button {
  opacity: 0;
}
</style>
